import store from "../store";
import route from "../router";
import {
  getMessageFromLast,
  getGroupMessageFromLast,
  getMessageBefore,
  getGroupMessageBefore,
  getFriendInfoById,
  getGroupInfoById,
} from "./chat";
// import { mapState, mapMutations } from 'vuex';
// mapMutations(['send', 'recive'])
import msgType from "@/common/msgTypeEnum.js";
import msgAction from "@/common/msgActionEnum.js";

export let webSocketUrl = process.env.VUE_APP_WEBSOCKET_URL;

var isReconnecting = false;
var reconnectInterval = 3000;
var retryCount = 0;

console.log("webSocketUrl:" + webSocketUrl);
let ws = null;
let userId = -1;

function reConnect(myId) {
  isReconnecting = true;
  setTimeout(() => {
    console.log("尝试重连", myId);
    retryCount = retryCount + 1;
    doConnect(myId);
    isReconnecting = false;
  }, reconnectInterval);
}

function doConnect(myId) {
  if (ws === null) {
    ws = new WebSocket(webSocketUrl + myId);
    console.log(webSocketUrl + myId);
    ws.onmessage = onMessage;
    ws.onopen = onOpen;
    ws.onclose = onClose;
    ws.onerror = onError;
  }
}

export function connect(myId) {
  if ("WebSocket" in window) {
    userId = myId;
    doConnect(myId);
  } else {
    alert("您的浏览器不支持 WebSocket!");
  }
}

export function disconnect() {
  if (ws !== null) {
    ws.close();
    ws = null;
    userId = -1;
  }
}

function onOpen() {
  console.log("WebSocket连接已打开", ws, store.state.msgContent, store);
  retryCount = 0;
  // store 方法调用示例
  store.commit("initChatList", "data");
}

function onClose(event) {
  console.log("WebSocket连接已关闭", event);
  ws = null;
  if (retryCount < 10 && !isReconnecting) {
    reConnect(userId);
  }
}

function onError(error) {
  console.error("WebSocket错误: ", error);
  ws = null;
}

/**
 * 收到消息的处理事件
 * 1.判断好友id，若当前打开了与好友的对话框，签收此消息
 * 若当前没有打开此好友对话框，若缓存了之前的聊天内容，红点提示
 *
 * 2.若没有缓存之前的聊天内容，请求缓存之前的一部分聊天内容
 *
 * @param {*} event
 */
function onMessage(event) {
  console.log("event, ", event, ws);
  const receivedMsg = JSON.parse(event.data);
  console.log("receivedMsg, ", receivedMsg);

  if (receivedMsg.action == 2) {
    // 单聊
    onSingleMessage(event);
  } else if (receivedMsg.action == 7) {
    // 群聊
    onGroupMessage(event);
  }
}

function onGroupMessage(event) {
  console.log("event, ", event, ws);
  const receivedMsg = JSON.parse(event.data);
  console.log("receivedMsg, ", receivedMsg);

  // 根据您的消息格式处理接收到的消息
  // 例如，将消息添加到聊天记录中
  let msgObj = tranChatDataFromWs(receivedMsg);
  // 如果与当前好友的聊天记录为空,创建绑定的属性
  if (!store.state.msgContent["g" + receivedMsg.chatMsg.groupId]) {
    store.commit("addChatMessage", {
      key: "g" + receivedMsg.chatMsg.groupId,
      value: [],
    });
  }
  // 将收到的ws数据存入store
  store.commit("reciveGroup", msgObj);

  // this.recive(msgObj);

  // TODO
  let friendIn = false;
  if (
    route.currentRoute.fullPath == "/home/mygroup" &&
    store.state.msgContent.tempGroupInfo &&
    receivedMsg.chatMsg.groupId == store.state.msgContent.tempGroupInfo.groupId
  ) {
    // if (receivedMsg.chatMsg.senderId == this.friendId) { // TODO this.friendId
    // 当前正在与该好友聊天，更新最近消息信息
    store.state.msgContent.group.forEach((item) => {
      // this.friList.forEach(item => { // TODO this.friList
      if (item.groupId == receivedMsg.chatMsg.groupId) {
        item.msg = receivedMsg.chatMsg.msg;
      }
    });
    // 向后台将该消息置为已读 TODO
    console.log("---ws--- read,", receivedMsg);
    ws.send(
      JSON.stringify({
        action: msgAction.GROUP_SIGNED,
        chatMsg: {
          groupId: receivedMsg.chatMsg.groupId,
          senderId: receivedMsg.chatMsg.senderId,
        },
        extand: "" + receivedMsg.chatMsg.msgId,
      })
    );
  } else if (!(friendIn = groupInTemp(receivedMsg.chatMsg.groupId))) {
    /**
     * 临时列表中没有该好友
     * 1.查询好友信息
     * 2.填充好友信息
     */
    // TODO

    getGroupInfoById({
      groupId: receivedMsg.chatMsg.groupId,
    })
      .then((response) => {
        let friendInfo = {
          sendUid: receivedMsg.chatMsg.senderId,
          acceptUid: receivedMsg.chatMsg.receiverId,
          friendId: receivedMsg.chatMsg.senderId,
          friendName: response.data.userName,
          friendAvatar: response.data.imageUrl,
          msg: receivedMsg.chatMsg.msg,
          addTime: getCurrentTime(),
          msgExtend: null,
          msgType: 0,
          deleted: null,
          unreadMessages: 1,
        };
        store.state.msgContent.group.push(friendInfo);
        console.log("this.friList", store.state.msgContent.group);
        store.dispatch("setIsNotify", true);
      })
      .catch((error) => {
        console.error("搜索消息出错:", error);
      });
  } else {
    // 临时列表中，该好友的未读消息+1
    store.state.msgContent.group.forEach((item) => {
      if (item.groupId == receivedMsg.chatMsg.groupId) {
        item.unreadMessages += 1;
        item.msg = receivedMsg.chatMsg.msg;
      }
    });
    console.log("this.friList", store.state.msgContent.group);
    store.dispatch("setIsNotify", true);
  }
  console.log("friendIn", friendIn);
}
function onSingleMessage(event) {
  const receivedMsg = JSON.parse(event.data);
  // 根据您的消息格式处理接收到的消息
  // 例如，将消息添加到聊天记录中
  console.log("onSingleMessage", receivedMsg);
  let msgObj = tranChatDataFromWs(receivedMsg);
  // 得到我的id
  let myId = store.state.user.id;
  // // 得到聊天信息中，好友的id
  // let friendId = myId == receivedMsg.chatMsg.senderId ? receivedMsg.chatMsg.receiverId : receivedMsg.chatMsg.senderId
  // 如果与当前好友的聊天记录为空,创建绑定的属性
  if (!store.state.msgContent[msgObj.friendId]) {
    store.commit("addChatMessage", {
      key: msgObj.friendId,
      value: [],
    });
  }
  // 将收到的ws数据存入store
  store.commit("recive", msgObj);

  // this.recive(msgObj);

  // TODO
  let friendIn = false;
  if (myId == receivedMsg.chatMsg.senderId) {
    // 如果是本人发送的消息，不做其他处理
  } else if (
    msgObj.friendId == store.state.msgContent.tempFriendId &&
    route.currentRoute.fullPath == "/home/mymsg"
  ) {
    // if (receivedMsg.chatMsg.senderId == this.friendId) { // TODO this.friendId
    // 当前正在与该好友聊天，更新最近消息信息
    store.state.msgContent.chat.forEach((item) => {
      // this.friList.forEach(item => { // TODO this.friList
      if (item.friendId == msgObj.friendId) {
        item.msg = receivedMsg.chatMsg.msg;
      }
    });
    // 向后台将该消息置为已读
    ws.send(
      JSON.stringify({
        action: msgAction.SIGNED,
        extand: "" + receivedMsg.chatMsg.msgId,
      })
    );
  } else if (!(friendIn = friendInTemp(msgObj.friendId))) {
    /**
     * 临时列表中没有该好友
     * 1.查询好友信息
     * 2.填充好友信息
     */
    // TODO

    getFriendInfoById({
      friendId: msgObj.friendId,
    })
      .then((response) => {
        let friendInfo = {
          sendUid: receivedMsg.chatMsg.senderId,
          acceptUid: receivedMsg.chatMsg.receiverId,
          friendId: msgObj.friendId,
          friendName: response.data.userName,
          friendAvatar: response.data.imageUrl,
          msg: receivedMsg.chatMsg.msg,
          addTime: getCurrentTime(),
          msgExtend: null,
          msgType: 0,
          deleted: null,
          unreadMessages: 1,
        };
        store.state.msgContent.chat.push(friendInfo);
        console.log("this.friList", store.state.msgContent.chat);
        store.dispatch("setIsNotify", true);
      })
      .catch((error) => {
        console.error("搜索消息出错:", error);
      });
  } else {
    // 临时列表中，该好友的未读消息+1
    store.state.msgContent.chat.forEach((item) => {
      if (item.friendId == msgObj.friendId) {
        item.unreadMessages += 1;
        item.msg = receivedMsg.chatMsg.msg;
      }
    });
    console.log("this.friList", store.state.msgContent.chat);
    store.dispatch("setIsNotify", true);
  }
  console.log("friendIn", friendIn);
}

function friendInTemp(friendId) {
  for (let i = 0; i < store.state.msgContent.chat.length; i++) {
    if (store.state.msgContent.chat[i].friendId == friendId) {
      return true;
    }
  }
  return false;
}
function groupInTemp(groupId) {
  for (let i = 0; i < store.state.msgContent.group.length; i++) {
    if (store.state.msgContent.group[i].groupId == groupId) {
      return true;
    }
  }
  return false;
}

function getCurrentTime() {
  //获取当前时间并打印
  let yy = new Date().getFullYear();
  let mm = new Date().getMonth() + 1;
  let dd = new Date().getDate();
  let hh = new Date().getHours();
  let mf =
    new Date().getMinutes() < 10
      ? "0" + new Date().getMinutes()
      : new Date().getMinutes();
  let ss =
    new Date().getSeconds() < 10
      ? "0" + new Date().getSeconds()
      : new Date().getSeconds();
  return yy + "/" + mm + "/" + dd + " " + hh + ":" + mf + ":" + ss;
}

export function sendGroupMessage(message) {
  console.log(
    "sendMessage, sender: " +
      store.state.user.id +
      ", groupId: " +
      store.state.msgContent.tempGroupInfo.groupId +
      ", message: " +
      message
  );
  if (message.trim() !== "") {
    ws.send(
      JSON.stringify({
        // 格式化您的消息对象
        action: msgAction.GROUP_CHAT,
        chatMsg: {
          msg: message,
          senderId: store.state.user.id,
          // receiverId: store.state.msgContent.tempFriendInfo.friendId,
          groupId: store.state.msgContent.tempGroupInfo.groupId,
          msgType: null,
        },
        extand: null,
      })
    );
    // 刚刚这条消息加入列表 因为ws会群发，这里就不重复发送了
    // let data = {
    //   groupId: store.state.msgContent.tempGroupInfo.groupId,
    //   senderId: store.state.user.id,
    //   time: getCurrentTime(),
    //   msg: message
    // }
    // store.commit("sendGroup", data)
  }
}
export function sendGroupMessageInShare(message, groupId) {
  console.log(
    "sendMessage, sender: " +
      store.state.user.id +
      ", groupId: " +
      groupId +
      ", message: " +
      message
  );
  if (message.trim() !== "") {
    ws.send(
      JSON.stringify({
        // 格式化您的消息对象
        action: msgAction.GROUP_CHAT,
        chatMsg: {
          msg: message,
          senderId: store.state.user.id,
          // receiverId: store.state.msgContent.tempFriendInfo.friendId,
          groupId: groupId,
          msgType: msgType.ARTICLE,
        },
        extand: message,
      })
    );
    // 刚刚这条消息加入列表 因为ws会群发，这里就不重复发送了
  }
}

/**
 * 向单人聊天中发送文章链接
 * @param {Object} url 文章url
 * @param {Object} title 文章标题
 * @param {Object} friendId 接收人id
 */
export function sendSingleArticleMessage(url, myId, title, friendId) {
  console.log(
    "sendMessage, sender: " +
      myId +
      ", receiver: " +
      friendId +
      ", title: " +
      title +
      ", url: " +
      url
  );
  if (title.trim() !== "") {
    // 组装发送至 ws 的消息
    let msgObj = {
      action: msgAction.CHAT,
      chatMsg: {
        msg: title,
        senderId: myId,
        receiverId: friendId,
        msgType: msgType.ARTICLE,
      },
      extand: url,
    };
    // 将消息发送至ws
    sendWsMessage(msgObj);

    // 将消息封装为列表展示的格式
    // let data = tranChatDataFromWs(msgObj);
    // 将消息存入前端列表
    // store.commit("send", data);
  }
}

/**
 * 向群聊天中发送文章链接
 * @param {Object} url 文章url
 * @param {Object} title 文章标题
 * @param {Object} groupId 通过 store.state.msgContent.tempGroupInfo.groupId 获取当前群组
 */
export function sendGroupArticleMessage(url, myId, title, groupId) {
  console.log(
    "sendMessage, sender: " +
      myId +
      ", groupId: " +
      groupId +
      ", title: " +
      title
  );
  if (title.trim() !== "") {
    ws.send(
      JSON.stringify({
        // 格式化您的消息对象
        action: msgAction.GROUP_CHAT,
        chatMsg: {
          msg: title,
          senderId: myId,
          groupId: groupId,
          msgType: msgType.ARTICLE,
        },
        extand: url,
      })
    );
  }
}

export function sendMessage(message) {
  console.log(
    "sendMessage, sender: " +
      store.state.user.id +
      ", receiver: " +
      store.state.msgContent.tempFriendInfo.friendId +
      ", message: " +
      message
  );
  if (message.trim() !== "") {
    // 组装发送至 ws 的消息
    let msgObj = {
      action: msgAction.CHAT,
      chatMsg: {
        msg: message,
        senderId: store.state.user.id,
        receiverId: store.state.msgContent.tempFriendInfo.friendId,
        groupId: 1,
        msgType: msgType.TXT,
      },
      extand: null,
    };
    // 将消息发送至ws
    sendWsMessage(msgObj);
    // 将消息封装为列表展示的格式
    // let data = tranChatDataFromWs(msgObj);
    // 将消息存入前端列表
    // store.commit("send", data);
  }
}
export function sendMessageInShare(message, friendId) {
  console.log(
    "sendMessage, sender: " +
      store.state.user.id +
      ", receiver: " +
      friendId +
      ", message: " +
      message
  );
  if (message.trim() !== "") {
    // 组装发送至 ws 的消息
    let msgObj = {
      action: msgAction.CHAT,
      chatMsg: {
        msg: message,
        senderId: store.state.user.id,
        receiverId: friendId,
        groupId: 1,
        msgType: msgType.ARTICLE,
      },
      extand: message,
    };
    // 将消息发送至ws
    sendWsMessage(msgObj);
    // 将消息封装为列表展示的格式
    // let data = tranChatDataFromWs(msgObj);
    // 将消息存入前端列表
    // store.commit("send", data);
  }
}
export function getMoreHistory(errCallbak) {
  let tempMsgList =
    store.state.msgContent[store.state.msgContent.tempFriendInfo.friendId];
  console.log("tempMsgList: ", tempMsgList);
  if (tempMsgList == null || tempMsgList.length == 0) {
    // 获取最近的消息记录
    getMessageFromLast({
      friendId: store.state.msgContent.tempFriendInfo.friendId,
      myId: store.state.user.id,
      start: 0,
    })
      .then((response) => {
        if (response.data.length == 0 && errCallbak) {
          errCallbak("没有更多消息了");
        }
        store.state.msgContent[store.state.msgContent.tempFriendInfo.friendId] =
          response.data;
      })
      .catch((error) => {
        console.error("搜索消息出错:", error);
        if (errCallbak) {
          errCallbak(error);
        }
      });
  } else {
    let { createTime, id } = tempMsgList[0];
    console.log(
      "获取用户：" +
        store.state.user.id +
        " 和用户：" +
        store.state.msgContent.tempFriendInfo.friendId +
        " 在时间： " +
        createTime +
        " 之前的几条消息记录。"
    );
    //

    getMessageBefore({
      friendId: store.state.msgContent.tempFriendInfo.friendId,
      myId: store.state.user.id,
      msgId: id,
    })
      .then((response) => {
        if (response.data.length == 0 && errCallbak) {
          errCallbak("没有更多消息了");
        }
        console.log(
          "0------------",
          store.state.msgContent[store.state.msgContent.tempFriendInfo.friendId]
        );
        store.state.msgContent[
          store.state.msgContent.tempFriendInfo.friendId
        ].unshift(...response.data);
        console.log(
          "`--------",
          store.state.msgContent[store.state.msgContent.tempFriendInfo.friendId]
        );
      })
      .catch((error) => {
        console.error("搜索消息出错:", error);
        if (errCallbak) {
          errCallbak(error);
        }
      });
  }
}

export function getMoreGroupHistory(errCallbak) {
  let tempMsgList =
    store.state.msgContent["g" + store.state.msgContent.tempGroupInfo.groupId];
  console.log("tempMsgList: ", tempMsgList);
  if (tempMsgList == null || tempMsgList.length == 0) {
    // 获取最近的消息记录
    getGroupMessageFromLast({
      groupId: store.state.msgContent.tempGroupInfo.groupId,
      userId: store.state.user.id,
      start: 0,
    })
      .then((response) => {
        if (response.rows.length == 0 && errCallbak) {
          errCallbak("没有更多消息了");
        }
        store.state.msgContent[
          "g" + store.state.msgContent.tempGroupInfo.groupId
        ] = response.rows;
      })
      .catch((error) => {
        console.error("搜索消息出错:", error);
        if (errCallbak) {
          errCallbak(error);
        }
      });
  } else {
    let { createTime, id } = tempMsgList[0];
    console.log(
      "获取用户：" +
        store.state.user.id +
        " 和用户：" +
        store.state.msgContent.tempGroupInfo.groupId +
        " 在时间： " +
        createTime +
        " 之前的几条消息记录。"
    );
    //

    let param = {
      groupId: store.state.msgContent.tempGroupInfo.groupId,
      userId: store.state.user.id,
      msgId: id,
    };
    console.log("--getGroupMessageBefore--", param);
    getGroupMessageBefore(param)
      .then((response) => {
        console.log(response);
        if (response.rows.length == 0 && errCallbak) {
          errCallbak("没有更多消息了");
        }
        console.log(
          "0------------",
          store.state.msgContent[
            "g" + store.state.msgContent.tempGroupInfo.groupId
          ]
        );
        store.state.msgContent[
          "g" + store.state.msgContent.tempGroupInfo.groupId
        ].unshift(...response.rows);
        console.log(
          "`--------",
          store.state.msgContent[
            "g" + store.state.msgContent.tempGroupInfo.groupId
          ]
        );
      })
      .catch((error) => {
        console.error("搜索消息出错:", error);
        if (errCallbak) {
          errCallbak(error);
        }
      });
  }
}

/**
 * 通过ws发送消息，消息体格式如下
 * {
    // 格式化您的消息对象
    action: 2,
    chatMsg: {
      msg: title,
      senderId: myId,
      receiverId: friendId,
      msgType: msgType.ARTICLE
    },
    extand: url,
  }
 * @param {Object} wsObject
 */
function sendWsMessage(wsObject) {
  ws.send(JSON.stringify(wsObject));
}

/**
 * 将发送给ws的数据，转换为列表展示的数据格式
 * @param {Object} wsObject
 *
 */
function tranChatDataFromWs(wsObject) {
  let {
    chatMsg: {
      msgId,
      msg,
      senderId,
      receiverId,
      msgType,
      groupId,
      userName,
      friendAvatar,
    },
    extand,
  } = wsObject;

  // 得到我的id
  let myId = store.state.user.id;
  // 得到聊天信息中，好友的id
  let friendId = myId == senderId ? receiverId : senderId
  console.log("tranChatDataFromWs", wsObject);
  return {
    id: msgId,
    sendUserId: senderId,
    acceptUserId: receiverId,
    friendId: friendId,
    msg: msg,
    createTime: getCurrentTime(),
    msgExtend: extand,
    signTime: getCurrentTime(),
    msgType: msgType,
    groupId: groupId,
    userName: userName,
    friendAvatar: friendAvatar,
  };
}
